import { View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { radius } from '@/theme/tokens';

interface IconTileProps {
  icon: keyof typeof Ionicons.glyphMap;
  bg: string;
  fg: string;
  size?: number;
}

/** Rounded square icon tile used on event rows and policy cards */
export function IconTile({ icon, bg, fg, size = 48 }: IconTileProps) {
  return (
    <View
      style={{
        width: size,
        height: size,
        borderRadius: radius.button,
        backgroundColor: bg,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Ionicons name={icon} size={size * 0.5} color={fg} />
    </View>
  );
}
